import React from 'react';
import { User, Clock } from 'lucide-react';

const SellerFlag = ({ seller }) => {
  const createdDate = seller?.createdAt ? new Date(seller.createdAt) : null;
  const formattedDate = createdDate ? 
    `${createdDate.toLocaleDateString('es-AR')} ${createdDate.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}` : 
    null;

  if (!seller) return null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border dark:border-gray-700">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-8 h-8 rounded-full flex items-center justify-center bg-blue-100 dark:bg-blue-900/50">
          <User className="w-5 h-5 text-blue-600 dark:text-blue-400" />
        </div>
        <div>
          <h3 className="font-medium text-gray-900 dark:text-white">
            {seller.displayName || 'Usuario'}
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Vendedor
          </p>
        </div>
      </div>

      {formattedDate && (
        <div className="ml-11 flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
          <Clock className="w-4 h-4" />
          {formattedDate}
        </div>
      )}
    </div>
  );
};

export default SellerFlag; 